export class FuelPrice {
    id!: string
    fuelDate!: Date
    fuelPrice!: number
    fuelType!: string
}
